<template>
  <div class="ticket-manage">
    <div class="manage-query">
      <el-form
        :inline="true"
        :model="query"
        ref="queryForm"
        :rules="queryRules"
        size="small"
        class="query-middle"
      >
        <el-form-item label="门店名称" prop="Name">
          <el-input v-model="query.Name"></el-input>
        </el-form-item>
        <el-form-item label="创建时间：" prop="StartTime" style="margin-left:20px;">
          <el-date-picker
            v-model="query.StartTime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width:200px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="—" prop="EndTime">
          <el-date-picker
            v-model="query.EndTime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width:200px"
          ></el-date-picker>
        </el-form-item>

        <el-form-item style="margin-left:20px;">
          <el-button type="primary" icon="el-icon-search" @click="loadStoreList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" icon="el-icon-circle-close" @click="clearQuery('queryForm')">清除</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="manage-content">
      <div class="main-left">
        <div class="main-title">
          <span>
            <i class="el-icon-folder-opened"></i>门店列表
          </span>
          <el-button-group>
            <!-- <el-button icon="el-icon-folder-opened" @click="exportTable" size="mini">导出</el-button> -->
            <el-button icon="el-icon-circle-plus-outline" type="primary" size="mini" @click="add">新增</el-button>
          </el-button-group>
        </div>
        <!-- 添加门店信息 -->
        <div>
          <el-dialog
            title="添加门店"
            :visible.sync="adddialogVisible"
            width="40%"
            :close-on-click-modal="false"
            @closed="closeDialog('addformRef')"
          >
            <el-form
              :model="addForm"
              status-icon
              :rules="addformrules"
              ref="addformRef"
              label-width="80px"
            >
              <el-form-item label="名称" prop="Name">
                <el-input v-model="addForm.Name"></el-input>
              </el-form-item>
              <!-- <el-form-item label="负责人" prop="ProjectName">
                <el-input v-model="addForm.ProjectName"></el-input>
              </el-form-item>-->
              <!-- <el-form-item label="类型" prop="Type">
                <el-input v-model="addForm.Type"></el-input>
              </el-form-item>-->
              <el-form-item label="电话号码" prop="Tel">
                <el-input v-model="addForm.Tel"></el-input>
              </el-form-item>
              <el-form-item label="地址" prop="Address">
                <el-input v-model="addForm.Address"></el-input>
              </el-form-item>
              <el-form-item label="许可证号" prop="License">
                <el-input v-model="addForm.License"></el-input>
              </el-form-item>
              <el-form-item label="备注" prop="Remark">
                <el-input v-model="addForm.Remark"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="adddialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="postModel('addformRef')">确 定</el-button>
            </span>
          </el-dialog>
        </div>
        <!-- 门店账户 -->
        <div>
          <el-dialog
            title="添加门店账户"
            :visible.sync="adddialogVisibleAccount"
            width="40%"
            :close-on-click-modal="false"
            @closed="closeAccountDialog('addformRefAccount')"
          >
            <el-form
              :model="addAccountForm"
              status-icon
              :rules="addAccountformrules"
              ref="addformRefAccount"
              label-width="80px"
            >
              <el-form-item prop="Uname" label="账户名称">
                <el-input v-model="addAccountForm.Uname"></el-input>
              </el-form-item>
              <el-form-item prop="NikeName" label="账户昵称">
                <el-input v-model="addAccountForm.NikeName"></el-input>
              </el-form-item>
              <el-form-item label="角色" prop="RoleId">
                <el-select v-model="addAccountForm.RoleId" filterable placeholder="请选择">
                  <el-option
                    v-for="item in optionsAccount.roles"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id"
                  >
                    <span style="float: left">{{ item.Type }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.Name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="adddialogVisibleAccount = false">取 消</el-button>
              <el-button type="primary" @click="postModelAccount('addformRefAccount')">确 定</el-button>
            </span>
          </el-dialog>
        </div>
        <div class="left-table">
          <el-table :data="tableData" height="753px" border style="width:100%">
            <!-- @selection-change="handleSelectionChange" -->
            <el-table-column type="selection" min-width="10" align="center"></el-table-column>
            <el-table-column label="名称" prop="Name" min-width="100" align="center"></el-table-column>
            <!-- <el-table-column label="负责人" prop="ProjectName" min-width="80" align="center"></el-table-column>
            <el-table-column label="类型" prop="Type" min-width="80" align="center"></el-table-column>-->
            <el-table-column label="地址" prop="Address" min-width="140" align="center"></el-table-column>
            <el-table-column label="创建时间" prop="ApplyTime" min-width="140" align="center">
               <template slot-scope="scope">
                  <p>{{scope.row.ApplyTime | dateFormat}}</p>
                </template>
            </el-table-column>
            <el-table-column label="状态" prop="Status" min-width="100" align="center" fixed="right">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.Status | statusTypeFormat(normalStatus)"
                  effect="dark"
                  size="small"
                >{{scope.row.Status | status2Format(normalStatus)}}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作" min-width="280" justify="space-between" fixed="right">
              <template slot-scope="scope">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-button-group>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="lookStore(scope.row.Id)"
                    >查看</el-button>
                    <el-button
                      size="mini"
                      type="warning"
                      @click="changeStore(scope.row.Id,1)"
                      v-if="scope.row.Status === 0"
                    >禁用</el-button>
                    <el-button
                      size="mini"
                      type="warning"
                      @click="changeStore(scope.row.Id,0)"
                      v-if="scope.row.Status === 1"
                    >启用</el-button>
                    <el-popconfirm title="确认删除吗？" v-on:onConfirm="changeStore(scope.row.Id,-1)">
                      <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                    <el-button
                      size="mini"
                      type="success"
                      @click="addStoreAccount(scope.row.Id,0)"
                      v-if="scope.row.Status === 0"
                    >添加账户</el-button>
                  </el-button-group>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="left-pagination">
          <el-pagination
            class="pagination-bottom"
            background
            layout="prev, pager, next, total,sizes,jumper"
            :total="total"
            :page-size="query.PageSize"
            :page-sizes="[10,20,50]"
            :current-page.sync="query.PageIndex"
            v-on:size-change="handleSizeChange"
            v-on:current-change="handleCurrentPageChange"
          ></el-pagination>
        </div>
      </div>
      <div class="main-right">
        <div class="main-title">
          <span>
            <i class="el-icon-document"></i> 查看
          </span>
          <el-button-group>
            <el-button type="warning" v-show="flag === 1" size="mini" @click="edit">编辑</el-button>
            <el-button type="success" v-show="flag===2" size="mini" @click="save">保存</el-button>
          </el-button-group>
        </div>
        <div class="right-table">
          <table class="input-form" v-show="flag === 1">
            <thead>
              <tr>
                <th colspan="2">门店信息</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>门店名称</td>
                <td>{{detail.Name}}</td>
              </tr>
              <!-- <tr>
                <td>类型</td>
                <td>{{detail.Type}}</td>
              </tr>
              <tr>
                <td>负责人</td>
                <td>{{detail.ProjectName}}</td>
              </tr> -->
              <tr>
                <td>门店地址</td>
                <td>{{detail.Address}}</td>
              </tr>
              <tr>
                <td>联系电话</td>
                <td>{{detail.Tel}}</td>
              </tr>
              <tr>
                <td>许可证号</td>
                <td>{{detail.License}}</td>
              </tr>
              <!-- <tr>
                <td>所属总店</td>
                <td>{{detail.CompanyName}}</td>
              </tr> -->
              <tr>
                <td>备注</td>
                <td>{{detail.Remark}}</td>
              </tr>
              <!-- <tr>
                <td>状态</td>
                <td>{{detail.Status | status2Format}}</td>
              </tr> -->
            </tbody>
          </table>
          <table class="input-form" v-show="flag === 2">
            <thead>
              <tr>
                <th colspan="2">门店信息</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>门店名称</td>
                <td>
                  <el-input v-model="detail.Name" placeholder="请输入"></el-input>
                </td>
              </tr>
              <!-- <tr>
                <td>类型</td>
                <td>
                  <el-select v-model="detail.type" placeholder="请选择">
                    <el-option
                      v-for="item in options.types"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </td>
              </tr> -->
              
              <tr>
                <td>门店地址</td>
                <td>
                  <el-input v-model="detail.Address" placeholder="请输入"></el-input>
                </td>
              </tr>
              <tr>
                <td>联系电话</td>
                <td>
                  <el-input v-model="detail.Tel" placeholder="请输入"></el-input>
                </td>
              </tr>
              <tr>
                <td>许可证号</td>
                <td>
                  <el-input v-model="detail.License" placeholder="请输入"></el-input>
                </td>
              </tr>
              <tr>
                <td>备注</td>
                <td>
                  <el-input v-model="detail.Remark" placeholder="请输入"></el-input>
                </td>
              </tr>
              <!-- <tr>
                <td>状态</td>
                <td>
                  <el-select v-model="detail.Status">
                    <el-option
                      v-for="item in normalStatus"
                      :key="item.key"
                      :label="item.val"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </td>
              </tr> -->
            </tbody>
          </table>

          <!--  显示门店账户列表 -->
          <div style="margin-top:30px;" v-show="flag === 1">
            <el-table :data="StoreMemberData" height="487px" border style="width:95%">
              <el-table-column type="selection" min-width="10" align="center"></el-table-column>
              <el-table-column label="用户名" prop="Uname" min-width="100" align="center"></el-table-column>
              <el-table-column label="账户昵称" prop="NikeName" min-width="120" align="center"></el-table-column>
              <el-table-column label="状态" prop="Status" min-width="100" align="center">
                <template slot-scope="scope">
                  <el-tag
                    :type="scope.row.Status | statusTypeFormat(normalStatus)"
                    effect="dark"
                    size="small"
                  >{{scope.row.Status | status2Format(normalStatus)}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="280" justify="space-between" fixed="right">
                <template slot-scope="scope">
                  <el-row type="flex" class="row-bg" justify="space-between">
                    <el-button-group>
                      <el-button
                        size="mini"
                        type="primary"
                        @click="lookAccountStore(scope.row.Id)"
                        v-if="scope.row.Status === 0"
                      >编辑</el-button>
                      <el-button
                        size="mini"
                        type="warning"
                        @click="changeAccountStore(scope.row.Id,1,'Disable')"
                        v-if="scope.row.Status === 0"
                      >禁用</el-button>
                      <el-button
                        size="mini"
                        type="warning"
                        @click="changeAccountStore(scope.row.Id,0,'Enable')"
                        v-if="scope.row.Status === 1"
                      >启用</el-button>
                      <el-popconfirm title="确认删除吗？" v-on:onConfirm="changeAccountStore(scope.row.Id,-1,'Delete')">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                      </el-popconfirm>
                    </el-button-group>
                  </el-row>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="pagination-bottom"
              background
              layout="prev, pager, next, total,sizes,jumper"
              :total="queryCom.Total"
              :page-size="queryCom.PageSize"
              :page-sizes="[10,20,50]"
              :current-page.sync="queryCom.PageIndex"
              v-on:size-change="handleSizeChangeCom"
              v-on:current-change="handleCurrentPageChangeCom"
            ></el-pagination>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { validateUsername,validatePhone } from "../common/element-validator";
import { status2Format, statusTypeFormat } from "../filters/filters";
import STORE from "@/api/store";
import { mapState } from "vuex";
import {  keyToVal,dateFormat } from "@/filters/filters";
export default {
  name: "StoreManage",
  data() {
    return {
      query: {
        Name: "",
        StartTime:"",
        EndTime:"",
        PageSize: 10,
        PageIndex: 1,
      },
      total: 0,
      tableData: [],
      adddialogVisible: false,
      options: {
        types: [{ label: "大巴", value: "1" }],
        status: [{ label: "大巴", value: "1" }],
      },
      detail: {
        Name: "",
        Address: "",
        License: "",
        Tel: "",
        status: "",
        // CompanyName:"",//所属总店
        Remark:"",//备注
        // Type: "",
        // ProjectName: "",
      },
      form: {
        Name: "",
        Type: "",
        Address: "",
        License: "",
        // officer: "",
        Tel: "",
        status: "",
      },
      addForm: {
        Name: "",
        Address: "",
        Tel: "",
        License: "",
        Remark: "",
        // officer: "",
        // type: "",
        // CompanyID: "E02C1680-DB17-4B10-9A1F-6923AAF9F0FC",
        // PointId: "35B2FA45-470F-4A7F-BDBD-B8FEBE522EBE",
      },
      flag: 0,
      queryRules: {},
      addformrules: {
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        Tel: [{ required: true, message: "请输入电话号码", trigger: "blur" },
        { validator: validatePhone, trigger: "blur" },],
        Address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        License: [
          { required: true, message: "请输人许可证号", trigger: "blur" },
        ],
      },

      //门店账户添加
      adddialogVisibleAccount: false,
      addAccountForm: {
        Id:"",
        StoreId: "",
        Uname: "",
        NikeName: "",
        RoleId: "",
      },
      addAccountformrules: {
        Uname: [
          { required: true, message: "请输入用户名", trigger: "blur" },
           { validator: validateUsername, trigger: "blur" },
        ],
        NikeName: [
          { required: true, message: "请输入账户昵称", trigger: "blur" },
        ],
        RoleId: [{ required: true, message: "请选择角色", trigger: "blur" }],
      },
      //获取门店账户的角色
      optionsAccount: {
        roles: [],
        types: [],
      },

      //门店下的账户列表显示
      StoreMemberData:[],
    
      queryCom:{
        StoreID:"",
        Total:0,
        PageSize: 10,
        PageIndex: 1,
      },
    };
  },
  filters: {
    status2Format,
    statusTypeFormat,
    keyToVal,
    dateFormat,
  },
  computed: {
    ...mapState("common", ["normalStatus"]),
  },
  methods: {
    //关闭弹窗后清空表单
    closeDialog(formname) {
      this.$refs[formname].clearValidate();
      this.$refs[formname].resetFields();

      // this.model.showPicList = [];
    },
    //清除查询条件，重新获取
    clearQuery(formName) {
      if (formName === "queryForm") {
        this.query = {
          Name: "",
          StartTime:"",
          EndTime:"",
          PageSize: 10,
          PageIndex: 1,
        };
        this.loadStoreList();
      }
    },

    //查看
    loadStoreList() {
      STORE.loadStoreList(this.query).then((res) => {
        this.total = res.content.Total;
        this.tableData = res.content.OnePageData;
      });
    },
    //通过id查询
    lookStore(Id) {
      const param = {
        Id,
      };
      STORE.lookStore(param).then((res) => {
        if (res.status === "success") {
          this.detail = res.content.data;
          this.loadCompany(Id);
          // this.StoreMemberData=res.content.dataMenber;
          this.flag = 1;
        } else {
          this.$message.error("获取失败");
        }
      });
    },

    //根据门店Id加载总店信息
    loadCompany(Id){
      this.queryCom.StoreID=Id;
      STORE.lookStoreByCompany(this.queryCom).then((res)=>{
        if(res.status=="success"){
          this.queryCom.Total=res.content.Total;
          this.StoreMemberData=res.content.OnePageData;
        }
      });
    },
    handleSizeChangeCom(val) {
      this.queryCom.PageSize = val;
    },
    //分页  页码改变
    handleCurrentPageChangeCom(val) {
      this.queryCom.PageIndex = val;
    },
    

    //添加
    postModel(formName) {
      this.$refs[formName].validate((success) => {
        if (success) {
          STORE.addStore(this.addForm).then((res) => {
            if (res.status === "success") {
              this.adddialogVisible = false;
              this.$message.success("添加成功!");
              this.loadStoreList();
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$message.error("请补全信息!");
        }
      });
    },
    //修改保存
    save() {
      STORE.updateStore(this.detail).then((res) => {
        if (res.status === "success") {
          this.$message.success("修改成功!");
          this.flag = 0; //修改成功，重新获取数据，修改flag
          this.loadStoreList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 禁用 删除
    changeStore(Id, status) {
      switch (status) {
        case 0:
          STORE.enableStore({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success("启用成功!");
              this.loadStoreList();
            } else {
              this.$message.error(res.msg);
            }
          });
          break;
        case 1:
          STORE.disableStore({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success("禁用成功!");
              this.loadStoreList();
            } else {
              this.$message.error(res.msg);
            }
          });
          break;
        case -1:
          STORE.deleteStore({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success("删除成功!");
              this.loadStoreList();
            } else {
              this.$message.error(res.msg);
            }
          });
          break;
        default:
          break;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
         
          return false;
        }
      });
    },
    getDetail(id) {
      this.flag = 1;
    },
    edit() {
      this.flag = 2;
    },
    changeState(row, type) {
      //row,type
    
    },

    add() {
      this.adddialogVisible = true;
      this.addForm = {
        Name: "",
        // officer: "",
        type: "",
        Address: "",
        Tel: "",
        License: "",
        CompanyID: "E02C1680-DB17-4B10-9A1F-6923AAF9F0FC",
        PointId: "35B2FA45-470F-4A7F-BDBD-B8FEBE522EBE",
      };
    },
    // exportTable() {},
    //查看照片
    viewPhotos() {},
    handleSizeChange(val) {
      this.query.PageSize = val;
    },
    //分页  页码改变
    handleCurrentPageChange(val) {
      this.query.PageIndex = val;
    },
    
    //封面上传之前判断
    uploadBefore(file) {
      let fileType = file.type,
        isImage = fileType.indexOf("image") != -1,
        isBig = file.size <= 1024 * 1024 * 10;
      if (!file) {
        this.$refs.upload.onError();
        this.$message.error("上传为空!");
        return false;
      }
      if (!isImage) {
        this.$refs.upload.onError();
        this.$message.error("只能上传图片!");
        return false;
      }
      if (!isBig) {
        this.$refs.upload.onError();
        this.$message.error("图片大小不能超过10MB!");
        return false;
      }
      return true;
    },
    //封面上传成功之后回传
    uploadSuccess(res) {
      //res, file, fileList
      this.$message.success("封面上传成功!");
      this.modelAdd.form.Cover = res.Data.id;
      //this.addAssetLog(this.modelAdd.form.Id, '资产图片添加', '图片添加成功');
    },
    uploadError() {
      this.$message.error("封面上传失败!");
    },
    uploadRemove(file, fileList) {
      // console.log("file", file);
      // console.log("fileList", fileList);
      // $.post(
      //   "/Attachment/ChangeAttachmentStatus",
      //   { AttachmentStatus: -1, AttachmentId: this.modelAdd.form.Cover },
      //   (r) => {
      //     if (r.Status == 1) {
      //       this.$message.success("封面删除成功！");
      //     } else {
      //       this.$message.error("封面删除失败！");
      //     }
      //   }
      // );
    },

    //添加门店账户
    addStoreAccount(Id) {
      this.addAccountForm.StoreId = Id;
      this.adddialogVisibleAccount = true;
      this.addAccountForm.Id="";
    },
    //关闭弹窗后清空表单
    closeAccountDialog(formname) {
      this.$refs[formname].clearValidate();
      this.$refs[formname].resetFields();
    },
    //创建门店账户
    postModelAccount(formName) {
     
      if(this.addAccountForm.Id=="" || this.addAccountForm==null){ //添加
        this.$refs[formName].validate((success) => {
          if (success) {
            STORE.addStoreAccount(this.addAccountForm).then((res) => {
              if (res.status === "success") {
                this.adddialogVisibleAccount = false;
                this.$message.success("添加成功!");
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            this.$message.error("请补全信息!");
          }
        });
      }
      else{ //编辑
        this.$refs[formName].validate((success) => {
          if (success) {
            STORE.updateStoreAccount(this.addAccountForm).then((res) => {
              if (res.status === "success") {
                this.adddialogVisibleAccount = false;
                this.$message.success("修改成功!");
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            this.$message.error("请补全信息!");
          }
        });
      }
    },
    //获取角色
    getRoles() {
      STORE.getRoles().then((res) => {
        if (res.status === "success") {
          this.optionsAccount.roles = res.content;
        } else {
          this.$message.error("获取数据失败!");
        }
      });
    },
    //获取景点类型
    getPointType() {
      STORE.getPointType().then((res) => {
        if (res.status === "success") {
          this.optionsAccount.types = res.content;
        } else {
          this.$message.error("获取数据失败!");
        }
      });
    },

    //编辑查看账户信息
    lookAccountStore(Id){
      this.adddialogVisibleAccount=true;
      const param = {
          Id,
      };
      STORE.lookStoreAccount(param).then((res) => {
        if (res.status === "success") {
          this.addAccountForm = res.content;
          // this.flag = 0;
        } else {
          this.$message.error("获取失败!");
        }
      });
    },
    //启用禁用删除操作
    changeAccountStore(Id,status,type){
      var change={
        type:type,
        Id:Id,
        status:status,
      };
      STORE.changeStoreAccount(change).then((res) => {
        if (res.status === "success") {
          if(type=="Disable"){
            this.$message.success("禁用成功!");
          }
          else if(type=="Enable"){
            this.$message.success("启用成功!");
          }
          else{
            this.$message.success("删除成功!");
          }
          this.loadStoreList();
          this.flag=0;
        } else {
          this.$message.error("操作失败!");
        }
      });
    },

  },
  created() {
    this.loadStoreList();
    this.getRoles();
    this.getPointType();
  },
  watch: {
    "query.PageSize": function () {
      this.loadStoreList();
    },
    "query.PageIndex": function () {
      this.loadStoreList();
    },
    "queryCom.PageSize":function(){
      this.loadCompany(this.queryCom.StoreID);
    },
    "queryCom.PageIndex":function(){
      this.loadCompany(this.queryCom.StoreID);
    },
  },
};
</script>
<style scoped lang="less">
.main-left {
  width: 30%;
  border-right: 1px solid #ddd;
  min-width: 620px;
}
.main-left .left-table {
  height: 753px;
}
.main-left .left-pagination {
  height: 40px;
  background: #dedede;
  text-align: center;
}
.left-pagination .pagination-bottom {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.main-right {
  flex: 1;
}
.right-table {
  padding: 20px;
}
.input-form {
  width: 95%;
  border-collapse: collapse;
  border: 1px solid #aaa;
  thead {
    width: 100%;
    background-color: #f1f1f1;
    border: 1px solid #aaa;
  }
  th,
  tr {
    height: 33px;
    border: 1px solid #aaa;
  }
  td,
  th {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #aaa;
  }
}
.input-form /deep/ .el-select {
  width: 100%;
}
.input-form /deep/ .el-input__inner {
  border: none;
  width: 100%;
}
</style>
